import React from "react";
import './App.css';
import { TopPage } from "./components/Pages/topPage";
import { BrowserRouter, Routes, Route} from "react-router-dom";
import { EntryFormPage } from "./components/Pages/entryFromPage";
import { RecoilRoot } from 'recoil';
import { EntryCompPage } from "./components/Pages/entryCompPage";

function App() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_DIR}>  
      <Routes>
            <Route path={`/`} element={
               <RecoilRoot> <TopPage /> </RecoilRoot>
            } />
             {/*
            <Route path={`/form`} element={
              <RecoilRoot> <EntryFormPage /> </RecoilRoot>
            } />*/
            <Route path={`/complate`} element={
              <RecoilRoot> <EntryCompPage></EntryCompPage> </RecoilRoot>
           } />
          }
      </Routes>
    </BrowserRouter>
  );
}

export default App;
